const styles = {
  blue: {
    color: "rgb(33,77,142)",
    paddingRight: "0",
  },
  red: {
    color: "rgb(220,38,72)",
    paddingLeft: "0",
  },
  regionLabel: {
    padding: "0",
    marginLeft: "16px",
    marginTop: "20px",
    marginBottom: "12px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0.2px",
    color: "#6D7885",
  },
  regionSelector: {
    width: "311px",
    marginLeft: "4.25vw",
    marginRight: "4.25vw",
  },
  nextButton: {
    width: "90vw",
    marginLeft: "5vw",
    marginTop: "10vh",
    backgroundColor: "rgb(33,77,142)",
    border: "1px solid rgb(33,77,142)",
    borderRadius: "0",
    height: "10vh",
  },
  containerMedicalOrganisations: {
    width: "90vw",
    marginLeft: "0",
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  medicalOrganisation: {
    fonFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "clamp(10px, 3.73vw, 22px)",
    lineHeight: "clamp(12px, 4.8vw, 29px)",
    letterSpacing: "0.2px",
    paddingLeft: "3vw",
    paddingRight: "3vw",
    color: "#000000",
  },
  medicalOrganisationDesc: {
    fontFamily: "IBM Plex Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "clamp(10px, 3.47vw, 20px)",
    lineHeight: "clamp(12px, 4.8vw, 27px)",
    color: "#06844D",
  },
  headerText: {
    fontFamily: "IBM Plex Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "23px",
    lineHeight: "28px",
    color: "#000000",
  },
  imgClose: {
    height: "13px",
    width: "13px",
  },
  wrapperSelectRegion: {
    display: "grid",
    gridTemplateColumns: "calc(86.15vw - 13px) 13px",
    columnGap: "4.25vw",
    alignItems: "center",
    padding: "0",
  },
  selectorLabel: {
    fontSize: "14px",
    fontFamily: "Roboto",
    lineHeight: "18px",
    letterSpacing: "0.2px",
    color: "#6D7885",
    marginBottom: "12px",
    marginLeft: "5.5px",
  },
  wrapper: {
    marginLeft: "18px",
    marginRight: "18px",
    width: "90.4vw",
    marginTop: "12px",
  },
  emptyContentMessage: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "296px",
    fontFamily: "Roboto",
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0.1px",
    color: "#818C99",
    fontWeight: "400",
    marginTop: "172px",
    textAlign: "center",
  },
  errorLabel: {
    paddingTop: "16px",
  },
};

export default styles;
